import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import { useParams } from 'react-router-dom'
import Events from '../../api/Events';
import sSimg from '../../images/resource/SkillSwapSocial.jpg';
import Subscribe2 from '../../components/Subscribe2/Subscribe2';
import Footer2 from '../../components/footer2/Footer2';
import VenueSection3 from '../../components/VenueSection/VenueSection3';


const EventSinglePage = (props) => {

    const eventDetails = Events[2];

    return (
        <Fragment>
            <Navbar hclass={'wpo-header-style-5'} topbarClass={'tb-block'} />
            <PageTitle pageTitle={eventDetails.eTitle} pagesub={'Event Details'} pageTitle2={'Event Details'}/>
            <section className="event-detail">
                <div className="auto-container">
                    <div className="inner-container">
                        <div className="event-detail_image">
                            <img src={sSimg} alt="" />
                        </div>
                        <div className="upper-box d-flex justify-content-between flex-wrap">
                            <h2 className="event-detail_title">{eventDetails.eTitle}</h2>
                            {/* <div className="event-detail_author">
                                <div className="event-detail_author-image">
                                    <img src={eventDetails.eImg} alt="" />
                                </div>
                                <div className="event-detail_author-name">{eventDetails.speaker}, <span>Art Critic</span></div>
                                <div className="event-detail_author-location"><span>Location:</span> Hall 1, Building, <br /> Golden Street , Southafrica</div>
                                <div className="event-detail_author-timing">08.00 am  09.00 am</div>
                                <div className="event-detail_author-icon flaticon-voice"></div>
                            </div> */}
                        </div>
                        <p>SkillSwap Social is where real people share real skills. It’s not a lecture hall—it’s a circle of thinkers, doers, and curious minds who come together to learn, teach, and grow through conversation and hands-on discovery. Here, every person is both a student and a mentor, and every exchange is a spark that can open new doors. SkillSwap isn’t about formalities—it’s about creating a space where knowledge feels personal, practical, and inspiring.</p>
                        <p>It is a curated community gathering designed to foster collaboration, creativity, and growth. Away from rigid structures, people connect through peer-led exchanges, mini-workshops, and interactive sessions that focus on what really matters—learning that sticks, relationships that last, and experiences that transform how you think and act.</p>
                        <div className="middle-column">
                            <div className="row clearfix">
                                <div className="column col-lg-6 col-md-12 col-sm-12">
                                    <h3 className="event-detail_subtitle">Key Points of the Event</h3>
                                    <ul className="event-detail_list">
                                        <li>Share your skills, stories, and lessons in an open circle of exchange.</li>
                                        <li>Learn something new—from everyday hacks to professional insights, directly from peers.</li>
                                        <li>Get featured in community highlights and peer-to-peer showcases.</li>
                                        <li>Be part of a culture that values curiosity, generosity, and shared growth.</li>
                                    </ul>
                                </div>
                                <div className="column col-lg-6 col-md-6 col-sm-12">
                                    <div className="event-detail_image-two">
                                        <img src="assets/images/resource/event-1.jpg" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p>SkillSwap Social is designed to break barriers between “expert” and “learner.” Here, you’ll find yourself discovering something unexpected, teaching something you didn’t know you could, and connecting with people who inspire you to keep growing. It’s about conversations that matter, experiences that stick, and a community that thrives on shared wisdom.</p>
                          <div className="appointmeny_button-box" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px', margin: '30px 0' }}>
                            <div style={{ flex: '0 0 auto' }}>
                                <a
                                    href="https://drive.google.com/file/d/1Cw8r73EVheh4wIFju-adXR-wn9X8jrS-/view"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="theme-btn btn-style-one"
                                >
                                    <span className="btn-wrap">
                                        <span className="text-one">Download Brochure</span>
                                        <span className="text-two">Download Brochure</span>
                                    </span>
                                </a>
                            </div>
                            <div style={{ flex: '0 0 auto', marginLeft: 'auto' }}>
                                <button
                                    type="button"
                                    className="theme-btn btn-style-one"
                                    disabled
                                    aria-disabled="true"
                                    style={{ cursor: 'not-allowed', opacity: 0.6 }}
                                >
                                    <span className="btn-wrap">
                                        <span className="text-one">Event Finished</span>
                                        <span className="text-two">Event Finished</span>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <Subscribe2 /> */}
            <VenueSection3 />
            <Footer2/>
            <Scrollbar />
        </Fragment>
    )
};
export default EventSinglePage;
